import { useEffect } from "react";

import {
  FetchProductVendorsQueryResult,
  useFetchProductVendorsQuery,
} from "@src/generated";

export function useProductVendors(options?: { skip?: boolean }) {
  const queryResult: FetchProductVendorsQueryResult =
    useFetchProductVendorsQuery({
      variables: { cursor: null },
      skip: options?.skip,
    });

  const fetchAllPages = async () => {
    if (!queryResult.data?.productVendors?.pageInfo.hasNextPage) {
      return;
    }
    let hasNextPage: boolean =
      queryResult.data?.productVendors?.pageInfo.hasNextPage ?? false;
    let endCursor: string | null | undefined =
      queryResult.data?.productVendors?.pageInfo.endCursor;

    while (hasNextPage && endCursor) {
      const result = await queryResult.fetchMore({
        variables: { cursor: endCursor },
      });

      hasNextPage = result.data?.productVendors?.pageInfo.hasNextPage ?? false;
      endCursor = result.data?.productVendors?.pageInfo.endCursor;
    }
  };

  useEffect(() => {
    if (!queryResult.loading && queryResult.data) {
      void fetchAllPages();
    }
  }, [queryResult.loading, queryResult.data]);

  return queryResult.data;
}
